import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import Button from '../../../common/form/Button';
import '../../../../styles/BlockProspectPopup.css';
import ConfirmBlockModal from './confirmBlockModal';

interface BlockProspectModalProps {
    isOpen: boolean;
    prospect: any | undefined;
    onClose: () => void;
    onBlock: (reason: string) => void;
    prospectUserId: any;
    propertyId: any;
}

const BlockProspectModal = ({
    isOpen,
    prospect,
    onClose,
    onBlock,
    prospectUserId,
    propertyId
}: BlockProspectModalProps) => {
    const [reason, setReason] = useState('');
    const [confirmState, setConfirm] = useState(false);

    const handleBlock = () => {
        if (!reason.trim()) {
            alert('Please provide a reason for blocking.');
            return;
        }

        setConfirm(true)
    };

    return (
        <>
        <Modal isOpen={isOpen && !confirmState} toggle={onClose} className="block-prospect-modal">
            <ModalBody>
                {/* Header */}
                <div className="block-modal-header">
                    <h5>Block Prospect</h5>
                    <div className="close-icon" onClick={onClose}>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.92422 0.326953C1.48359 -0.108984 0.771094 -0.108984 0.330469 0.326953C-0.110156 0.762891 -0.105469 1.48008 0.330469 1.9207L8.90859 10.4988L0.330469 19.077C-0.110156 19.5176 -0.110156 20.2301 0.330469 20.666C0.771094 21.102 1.48359 21.1066 1.91953 20.666L10.4977 12.0879L19.0805 20.6707C19.5211 21.1113 20.2336 21.1113 20.6695 20.6707C21.1055 20.2301 21.1102 19.5176 20.6695 19.0816L12.0914 10.5035L20.6742 1.9207C21.1148 1.48008 21.1148 0.767578 20.6742 0.331641C20.2336 -0.104297 19.5211 -0.108984 19.0852 0.331641L10.507 8.90977L1.92422 0.326953Z"
                                fill="#333"
                            />
                        </svg>
                    </div>
                </div>

                <h5 className="prospect-head">Prospect</h5>

                {/* Prospect Name */}
                <h4 className="prospect-name">{prospect ? `${prospect.firstName} ${prospect.lastName}` : ''}</h4>

                {/* Reason Input */}
                <div className="reason-input">
                    <label htmlFor="reason">REASON FOR BLOCKING*</label>
                    <textarea
                        id="reason"
                        placeholder="Provide the reason for blocking"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    />
                </div>

                {/* Block Button */}
                <div className="block-button-wrapper">
                    <Button addlClassName="btn-danger" text="Block" onClick={handleBlock} />
                </div>
            </ModalBody>
        </Modal>
        <ConfirmBlockModal isOpen={confirmState} blockReason={reason} prospectName={prospect ? `${prospect.firstName} ${prospect.lastName}` : ''} onClose={function (): void {
                setConfirm(false);
                onClose();
            } } onConfirm={function (): void {
                setConfirm(false);
                onBlock(reason);
                onClose();
            } } prospectUserId={prospectUserId} propertyId={propertyId}/>
        </>
    );
};

export default BlockProspectModal;



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/blockProspectPopup.tsx